import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MixMatchState = {
  clickedChipList: { id: string };
  price: {
    frameP: number;
    lensP: number;
    totalP: number;
  };
  hideAddToCartButton: boolean;
  prescriptionToggled: boolean;
};

const initialState: MixMatchState = {
  clickedChipList: { id: '' },
  price: {
    frameP: 0,
    lensP: 0,
    totalP: 0,
  },
  hideAddToCartButton: false,
  prescriptionToggled: false,
};

const MixMatchSlice = createSlice({
  name: 'mixmatch',
  initialState: initialState,
  reducers: {
    setClickedChipList: (state, { payload }: PayloadAction<{ id: string }>) => {
      state.clickedChipList = payload;
    },
    setLensPrice: (state, { payload }: PayloadAction<number>) => {
      state.price.lensP = payload;
    },
    setFramePrice: (state, { payload }: PayloadAction<number>) => {
      state.price.frameP = payload;
    },
    setTotalPrice: (state, { payload }: PayloadAction<number>) => {
      state.price.totalP = payload;
    },
    setHideAddToCartButton: (state, { payload }: PayloadAction<boolean>) => {
      state.hideAddToCartButton = payload;
    },
    setPrescriptionToggled: (state, { payload }: PayloadAction<boolean>) => {
      state.prescriptionToggled = payload;
    },
  },
});

export const mixMatchReducer = MixMatchSlice.reducer;
export const mixMatchActions = MixMatchSlice.actions;
